function getLabelForCard(resource) {
  switch (resource.card?.type) {
    case "audio":
      return "Lyd";
    case "component":
      return "Digitalt redskab";
    case "document":
      return "Dokument";
    case "encyclopedia":
      return "Opslagsværk";
    case "evaluation":
      return "Evaluering";
    case "image":
      return "Billede";
    case "link":
      return "Link";
    case "notebook":
      return "Notesbog";
    case "task":
      return "Opgave";
    case "text":
      return "Tekst";
    case "text-with-audio":
      return "Tekst m. lyd";
    case "video":
      return "Video";
    case "goal":
      return "Mål";
    case "teacher":
      return "Til læreren";
  }
}

export { getLabelForCard };
//# sourceMappingURL=util.get-label.js.map
